var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B0E4CB9E-0305-4A19-964B-E23B5F48B6A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.1-Procedure-Builder---Procedure-Name-Added",
    transform: "translate(-24.000000, -303.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share2",
    transform: "translate(0.000000, 279.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8103044,0.018735363 L4.81498829,0.018735363 C2.16625761,0.018735363 0.018735363,2.16625761 0.018735363,4.81498829 L0.018735363,19.2037471 C0.018735363,21.8524778 2.16625761,24 4.81498829,24 L19.2037471,24 C21.8524778,24 24,21.8524778 24,19.2037471 C24,16.4806745 24,13.2084309 24,13.2084309 C24,12.546548 23.4628197,12.0093677 22.8009368,12.0093677 C22.1390539,12.0093677 21.6018735,12.546548 21.6018735,13.2084309 L21.6018735,19.2037471 C21.6018735,20.5275129 20.5275129,21.6018735 19.2037471,21.6018735 C15.2108665,21.6018735 8.80666979,21.6018735 4.81498829,21.6018735 C3.49002342,21.6018735 2.41686183,20.5275129 2.41686183,19.2037471 C2.41686183,15.2108665 2.41686183,8.80666979 2.41686183,4.81498829 C2.41686183,3.49002342 3.49002342,2.41686183 4.81498829,2.41686183 L10.8103044,2.41686183 C11.4721874,2.41686183 12.0093677,1.8796815 12.0093677,1.21779859 C12.0093677,0.555915691 11.4721874,0.018735363 10.8103044,0.018735363 Z M19.9063981,2.41686183 L15.6065574,2.41686183 C14.9446745,2.41686183 14.4074941,1.8796815 14.4074941,1.21779859 C14.4074941,0.555915691 14.9446745,0.018735363 15.6065574,0.018735363 L22.8009368,0.018735363 C23.4628197,0.018735363 24,0.555915691 24,1.21779859 L24,8.41217799 C24,9.07406089 23.4628197,9.61124122 22.8009368,9.61124122 C22.1390539,9.61124122 21.6018735,9.07406089 21.6018735,8.41217799 L21.6018735,4.11233724 L12.8571054,12.8571054 C12.3894707,13.32474 11.6292646,13.32474 11.16163,12.8571054 C10.6927963,12.3894707 10.6927963,11.6292646 11.16163,11.16163 L19.9063981,2.41686183 Z",
    id: "Shape",
    fill: "#000000"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share3.1826b92e1637bf62a40b33b3740855c1.svg";